import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BasePageComponent } from '../../../core/classes/base-page';
import { ExpanseCategoryService } from '../../../core/api/expanse-category.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { LoadingService } from '../../../core/services/loading.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-expense-category',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './expense-category.component.html',
  styleUrl: './expense-category.component.scss',
})
export class ExpenseCategoryComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: ExpanseCategoryService,
    public override authService: AuthService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'name',
      'type',
      'teams',
      'approver',
      'budget',
      'created_at',
      'updated_at',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'name';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  addCategory() {
    this.router.navigate(['/dashboard/expense-category/action'], {
      queryParams: {
        m: 'add',
      },
    });
  }

  editCategory(id: any) {
    this.router.navigate(['/dashboard/expense-category/action'], {
      queryParams: {
        m: 'edit',
        id,
      },
    });
  }

  getTeams(teams: any): string {
    const result: string[] = [];
    if (teams.length) {
      for (const item of teams) {
        result.push(item.team?.name);
      }
    } else {
      return '-';
    }
    return result.join(', ');
  }

  getApprovers(flow: any): string {
    const result: string[] = [];
    if (flow.length) {
      for (const item of flow
        .filter((item: any) => item.category == 'APPROVAL')
        .sort((a: any, b: any) => a.id - b.id)) {
        result.push(item.user?.firstName + ' ' + item.user?.lastName);
      }
    } else {
      return '-';
    }
    return result.join(', ');
  }
}
